(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9787],{

/***/ 1061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Gallery; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/dist/index.es.js
var index_es = __webpack_require__(92879);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/style.css
var style = __webpack_require__(23955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__Wrapper",
  componentId: "sc-14sd62t-0"
})(["display:flex;align-items:center;justify-content:center;flex-wrap:wrap;"]);
var PicWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__PicWrapper",
  componentId: "sc-14sd62t-1"
})(["margin:", ";width:90%;@media (min-width:", "px){width:40%;}@media (min-width:", "px){width:30%;}"], (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg);
var PicSource = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Galleryelements__PicSource",
  componentId: "sc-14sd62t-2"
})(["width:100%;cursor:pointer;border-radius:", ";"], (0,polished_esm/* rem */.hO)(16));
var Gallery_elements_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Galleryelements__Title",
  componentId: "sc-14sd62t-3"
})(["font-weight:", ";font-size:", ";width:100%;text-align:center;margin-top:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.tsx













var GalleryTemplate = function GalleryTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var CompanyCoursesImage = [(0,url_utils/* publicAssets */.VK)('/events1.webp'), (0,url_utils/* publicAssets */.VK)('/events6.webp'), (0,url_utils/* publicAssets */.VK)('/events2.webp'), (0,url_utils/* publicAssets */.VK)('/events3.webp'), (0,url_utils/* publicAssets */.VK)('/events5.webp'), (0,url_utils/* publicAssets */.VK)('/events4.webp')];
  var AboutUsImage = [(0,url_utils/* publicAssets */.VK)('/about6.webp'), (0,url_utils/* publicAssets */.VK)('/about1.webp'), (0,url_utils/* publicAssets */.VK)('/about3.webp'), (0,url_utils/* publicAssets */.VK)('/about4.webp'), (0,url_utils/* publicAssets */.VK)('/about2.webp'), (0,url_utils/* publicAssets */.VK)('/about5.webp')];

  var _useState = (0,react.useState)(false),
      showAll = _useState[0],
      setShowAll = _useState[1];

  var _useState2 = (0,react.useState)(false),
      imgFocus = _useState2[0],
      setImgFocus = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      imgIndex = _useState3[0],
      setImgIndex = _useState3[1];

  var _useState4 = (0,react.useState)(router.pathname.includes(constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US) ? AboutUsImage : CompanyCoursesImage),
      images = _useState4[0],
      setImages = _useState4[1];

  var minImgShowCount = 6;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H3 */.Z.H3,
      isBlack: true,
      children: t('about.gallery.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: images.map(function (img, index) {
        return showAll || index < minImgShowCount ? /*#__PURE__*/(0,jsx_runtime.jsx)(PicWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PicSource, {
            src: img,
            onClick: function onClick() {
              setImgIndex(index);
              setImgFocus(true);
            }
          })
        }, index) : null;
      })
    }), imgFocus && /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
      mainSrc: images[imgIndex],
      nextSrc: images[(imgIndex + 1) % images.length],
      prevSrc: images[(imgIndex + images.length - 1) % images.length],
      onCloseRequest: function onCloseRequest() {
        return setImgFocus(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return setImgIndex((imgIndex + images.length - 1) % images.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setImgIndex((imgIndex + 1) % images.length);
      }
    })]
  });
};

/* harmony default export */ var Gallery = (GalleryTemplate);

/***/ }),

/***/ 74066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ firemni_kurzy; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CompanyCoursesAreas/CompanyCoursesAreas.elements.tsx




var Transportation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCoursesAreaselements__Transportation",
  componentId: "sc-2msgob-0"
})(["display:flex;flex-direction:column;margin:", " 0;padding:", ";@media (min-width:", "px){flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(10));
var TransportationOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCoursesAreaselements__TransportationOptions",
  componentId: "sc-2msgob-1"
})(["width:100%;padding:", " 0;@media (min-width:", "px){width:65%;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md);
var TransportationOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCoursesAreaselements__TransportationOption",
  componentId: "sc-2msgob-2"
})([""]);
var TransportationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCoursesAreaselements__TransportationHeader",
  componentId: "sc-2msgob-3"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:", " 0;border-bottom:1px solid ", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
});
var TransportationHeaderTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CompanyCoursesAreaselements__TransportationHeaderTitle",
  componentId: "sc-2msgob-4"
})(["font-size:", ";"], (0,polished_esm/* rem */.hO)(18));
var TransportationHeaderIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "CompanyCoursesAreaselements__TransportationHeaderIcon",
  componentId: "sc-2msgob-5"
})(["svg{width:", ";height:", ";}&.isOpen{svg{transform:rotate(180deg);}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var TransportationDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCoursesAreaselements__TransportationDescription",
  componentId: "sc-2msgob-6"
})(["padding:", " 0;.withBorder{text-decoration:underline;display:block;padding:", " 0;}li{margin:", " 0;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CompanyCoursesAreas/CompanyCoursesAreas.tsx








var AREAS;

(function (AREAS) {
  AREAS["MANAGEMENT"] = "management";
  AREAS["SHOP"] = "shop";
  AREAS["DEVELOPMENT_SHOP"] = "developmentShop";
  AREAS["DEVELOPMENT_PERSON"] = "developmentPerson";
  AREAS["FINANCIAL_MANAGEMENT"] = "financialManagement";
  AREAS["HR"] = "hr";
  AREAS["EDUCATION"] = "education";
  AREAS["MARKETING_STRATEGY"] = "marketingStrategy";
  AREAS["TRENDS"] = "trends";
  AREAS["EDI"] = "edi";
})(AREAS || (AREAS = {}));

var CompanyCoursesAreasTemplate = function CompanyCoursesAreasTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)([]),
      openedAreas = _useState[0],
      setOpenedAreas = _useState[1];

  var toggleTransportationOption = function toggleTransportationOption(option) {
    openedAreas.includes(option) ? setOpenedAreas([]) : setOpenedAreas([option]);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    mobileSidePadding: 20,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Transportation, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        alignLeft: true,
        isBlack: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.areas.title')
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationOptions, {
        children: Object.values(AREAS).map(function (area, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
              onClick: function onClick() {
                return toggleTransportationOption(area);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
                children: t("companyCourses.areas.".concat(area, ".label"))
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
                className: openedAreas.includes(area) ? 'isOpen' : 'isClose',
                name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
              })]
            }), openedAreas.includes(area) && /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationDescription, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: t("companyCourses.areas.".concat(area, ".description"))
                }
              })
            })]
          }, key);
        })
      })]
    })
  });
};

/* harmony default export */ var CompanyCoursesAreas = (CompanyCoursesAreasTemplate);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/contact.service.ts
var contact_service = __webpack_require__(20644);
;// CONCATENATED MODULE: ./src/components/CompanyCoursesContactForm/ContactForm.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Background",
  componentId: "sc-1fmb4gr-0"
})(["background:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(240));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Wrapper",
  componentId: "sc-1fmb4gr-1"
})(["padding:", ";margin-top:", ";display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(20));
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Form",
  componentId: "sc-1fmb4gr-2"
})(["background:", ";padding:", ";border-radius:", ";margin-bottom:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(-200));
var FormFieldsStyles = (0,styled_components_browser_esm/* css */.iv)(["width:100%;padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";display:block;&.error{margin-bottom:0;border-color:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(700));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ContactFormelements__Input",
  componentId: "sc-1fmb4gr-3"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(50));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__ErrorMessage",
  componentId: "sc-1fmb4gr-4"
})(["margin:", " 0 ", " 0;display:block;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textBase;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.danger;
});
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__GlobalErrorMessage",
  componentId: "sc-1fmb4gr-5"
})(["color:", ";padding-top:", ";margin-bottom:-", ";display:block;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10));
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__SuccessMessage",
  componentId: "sc-1fmb4gr-6"
})(["color:", ";padding-top:", ";display:block;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(20));
;// CONCATENATED MODULE: ./src/components/CompanyCoursesContactForm/ContactForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var CompanyCoursesContactFormTemplate = function CompanyCoursesContactFormTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var nameInputRef = (0,react.useRef)();
  var emailInputRef = (0,react.useRef)();
  var phoneInputRef = (0,react.useRef)();
  var companyInputRef = (0,react.useRef)();
  var topicInputRef = (0,react.useRef)();
  var countInputRef = (0,react.useRef)();
  var sizeInputRef = (0,react.useRef)();
  var termInputRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      hasNameError = _useState[0],
      setHasNameError = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasPhoneError = _useState2[0],
      setHasPhoneError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasEmailError = _useState3[0],
      setHasEmailError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      hasTopicError = _useState4[0],
      setHasTopicError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      hasSentError = _useState5[0],
      setHasSentError = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isSent = _useState7[0],
      setIsSent = _useState7[1];

  var _useState8 = (0,react.useState)(null),
      token = _useState8[0],
      setToken = _useState8[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _nameInputRef$current, _nameInputRef$current2, _phoneInputRef$curren, _phoneInputRef$curren2, _emailInputRef$curren, _emailInputRef$curren2, _topicInputRef$curren, _topicInputRef$curren2;

      var hasError, _window, _window$fbq, _nameInputRef$current3, _phoneInputRef$curren3, _emailInputRef$curren3, _topicInputRef$curren3, _companyInputRef$curr, _companyInputRef$curr2, _countInputRef$curren, _countInputRef$curren2, _sizeInputRef$current, _sizeInputRef$current2, _termInputRef$current, _termInputRef$current2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasNameError(false);
              setHasPhoneError(false);
              setHasEmailError(false);
              setHasTopicError(false);
              setHasSentError(false);
              setIsSent(false);
              hasError = false;

              if (!(nameInputRef !== null && nameInputRef !== void 0 && (_nameInputRef$current = nameInputRef.current) !== null && _nameInputRef$current !== void 0 && _nameInputRef$current.value) || (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) === '') {
                setHasNameError(true);
                hasError = true;
              }

              if (!(phoneInputRef !== null && phoneInputRef !== void 0 && (_phoneInputRef$curren = phoneInputRef.current) !== null && _phoneInputRef$curren !== void 0 && _phoneInputRef$curren.value) || (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value) === '') {
                setHasPhoneError(true);
                hasError = true;
              }

              if ((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value)) {
                setHasEmailError(true);
                hasError = true;
              }

              if (!(topicInputRef !== null && topicInputRef !== void 0 && (_topicInputRef$curren = topicInputRef.current) !== null && _topicInputRef$curren !== void 0 && _topicInputRef$curren.value) || (topicInputRef === null || topicInputRef === void 0 ? void 0 : (_topicInputRef$curren2 = topicInputRef.current) === null || _topicInputRef$curren2 === void 0 ? void 0 : _topicInputRef$curren2.value) === '') {
                setHasTopicError(true);
                hasError = true;
              }

              if (!hasError) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return");

            case 13:
              _context.prev = 13;
              setIsLoading(true);
              (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', constants/* FBQ_EVENTS.LEAD */.PT.LEAD);
              _context.next = 18;
              return contact_service/* contactApi.companyCoursesOrder */.e.companyCoursesOrder(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                name: nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value,
                phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren3 = phoneInputRef.current) === null || _phoneInputRef$curren3 === void 0 ? void 0 : _phoneInputRef$curren3.value,
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value,
                topic: topicInputRef === null || topicInputRef === void 0 ? void 0 : (_topicInputRef$curren3 = topicInputRef.current) === null || _topicInputRef$curren3 === void 0 ? void 0 : _topicInputRef$curren3.value
              }, (companyInputRef === null || companyInputRef === void 0 ? void 0 : (_companyInputRef$curr = companyInputRef.current) === null || _companyInputRef$curr === void 0 ? void 0 : _companyInputRef$curr.value) !== '' && {
                company: companyInputRef === null || companyInputRef === void 0 ? void 0 : (_companyInputRef$curr2 = companyInputRef.current) === null || _companyInputRef$curr2 === void 0 ? void 0 : _companyInputRef$curr2.value
              }), (countInputRef === null || countInputRef === void 0 ? void 0 : (_countInputRef$curren = countInputRef.current) === null || _countInputRef$curren === void 0 ? void 0 : _countInputRef$curren.value) !== '' && {
                participantCount: countInputRef === null || countInputRef === void 0 ? void 0 : (_countInputRef$curren2 = countInputRef.current) === null || _countInputRef$curren2 === void 0 ? void 0 : _countInputRef$curren2.value
              }), (sizeInputRef === null || sizeInputRef === void 0 ? void 0 : (_sizeInputRef$current = sizeInputRef.current) === null || _sizeInputRef$current === void 0 ? void 0 : _sizeInputRef$current.value) !== '' && {
                numberOfDays: sizeInputRef === null || sizeInputRef === void 0 ? void 0 : (_sizeInputRef$current2 = sizeInputRef.current) === null || _sizeInputRef$current2 === void 0 ? void 0 : _sizeInputRef$current2.value
              }), (termInputRef === null || termInputRef === void 0 ? void 0 : (_termInputRef$current = termInputRef.current) === null || _termInputRef$current === void 0 ? void 0 : _termInputRef$current.value) !== '' && {
                date: termInputRef === null || termInputRef === void 0 ? void 0 : (_termInputRef$current2 = termInputRef.current) === null || _termInputRef$current2 === void 0 ? void 0 : _termInputRef$current2.value
              }), {}, {
                token: token
              }));

            case 18:
              setIsSent(true);
              setIsLoading(false);
              emailInputRef.current.value = '';
              nameInputRef.current.value = '';
              phoneInputRef.current.value = '';
              topicInputRef.current.value = '';
              companyInputRef.current.value = '';
              countInputRef.current.value = '';
              sizeInputRef.current.value = '';
              termInputRef.current.value = '';
              _context.next = 33;
              break;

            case 30:
              _context.prev = 30;
              _context.t0 = _context["catch"](13);
              setHasSentError(true);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 30]]);
    }));

    return function handleClick() {
      return _ref.apply(this, arguments);
    };
  }();

  var verifyRecaptchaCallback = (0,react.useCallback)(function (token) {
    setToken(token);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    children: [hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
            alignLeft: true,
            isBlack: true,
            children: t('companyCourses.contact.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: nameInputRef,
            placeholder: t('companyCourses.contact.input.name.placeholder'),
            className: "".concat(hasNameError ? 'error' : '')
          }), hasNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('companyCourses.contact.input.name.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: companyInputRef,
            placeholder: t('companyCourses.contact.input.company.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: phoneInputRef,
            placeholder: t('companyCourses.contact.input.phone.placeholder'),
            className: "".concat(hasPhoneError ? 'error' : '')
          }), hasPhoneError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('companyCourses.contact.input.phone.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: emailInputRef,
            placeholder: t('companyCourses.contact.input.mail.placeholder'),
            className: "".concat(hasEmailError ? 'error' : '')
          }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('companyCourses.contact.input.mail.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: topicInputRef,
            placeholder: t('companyCourses.contact.input.topic.placeholder'),
            className: "".concat(hasTopicError ? 'error' : '')
          }), hasTopicError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('companyCourses.contact.input.topic.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: countInputRef,
            placeholder: t('companyCourses.contact.input.count.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: sizeInputRef,
            placeholder: t('companyCourses.contact.input.size.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: termInputRef,
            placeholder: t('companyCourses.contact.input.term.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
            onVerify: verifyRecaptchaCallback
          }), (hasNameError || hasPhoneError || hasEmailError || hasTopicError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
            children: t('contact.form.error')
          }), !isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: isLoading,
            marginTop: 30,
            onClick: handleClick,
            text: t('companyCourses.contact.button')
          }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: t('contact.form.sent')
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ContactForm = (CompanyCoursesContactFormTemplate);
;// CONCATENATED MODULE: ./src/components/CompanyCoursesProcess/CompanyCourses.elements.tsx




var CompanyCourses_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCourseselements__Wrapper",
  componentId: "sc-13cq9lo-0"
})(["display:flex;gap:", ";flex-wrap:wrap;margin:", " 0 ", " 0;justify-content:center;@media (min-width:", "px){flex-direction:row;justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(35), theme/* breakpoints.sm */.A.sm);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCourseselements__Section",
  componentId: "sc-13cq9lo-1"
})(["display:flex;flex-direction:column;width:100%;margin-bottom:", ";padding:", " ", ";border-radius:", ";border:1px solid ", ";@media (min-width:", "px){width:23%;margin-bottom:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(16), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(45));
var SectionIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "CompanyCourseselements__SectionIcon",
  componentId: "sc-13cq9lo-2"
})(["display:block;margin-bottom:", ";svg{width:", ";height:", ";}&.board,&.feedback{svg{width:", ";height:", ";margin-top:", ";}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(-10));
var SectionLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CompanyCourseselements__SectionLabel",
  componentId: "sc-13cq9lo-3"
})(["color:", ";font-size:", ";line-height:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30));
;// CONCATENATED MODULE: ./src/components/CompanyCoursesProcess/CompanyCoursesProcess.tsx









var CompanyCoursesProcessTemplate = function CompanyCoursesProcessTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('companyCourses.process.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CompanyCourses_elements_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          name: Icon/* Icons.Zoom */.PJ.Zoom
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          name: Icon/* Icons.Calendar */.PJ.Calendar
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          className: "board",
          name: Icon/* Icons.Board */.PJ.Board
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          className: "feedback",
          name: Icon/* Icons.Feedback */.PJ.Feedback
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var CompanyCoursesProcess = (CompanyCoursesProcessTemplate);
// EXTERNAL MODULE: ./src/ui/TeamPerson/TeamPerson.tsx + 1 modules
var TeamPerson = __webpack_require__(30213);
;// CONCATENATED MODULE: ./src/components/CompanyCoursesSupport/CompanyCoursesSupport.elements.tsx



var Persons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCoursesSupportelements__Persons",
  componentId: "sc-13un8tb-0"
})(["padding:", " 0 ", " 0;display:flex;flex-direction:column;align-items:center;gap:", ";@media (min-width:", "px){flex-direction:row;justify-content:center;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm);
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "CompanyCoursesSupportelements__Description",
  componentId: "sc-13un8tb-1"
})(["font-size:", ";line-height:", ";color:", ";margin:", " auto ", " auto;max-width:", ";@media (min-width:", "px){text-align:center;margin:-", " auto ", " auto;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(550), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
;// CONCATENATED MODULE: ./src/components/CompanyCoursesSupport/CompanyCoursesSupport.tsx








var TEAMS = [{
  image: '/z_jureckova.webp',
  name: 'Šárka Jurečková',
  position: 'Manažerka pro firemní kurzy',
  phones: ['+420 602 398 155'],
  mail: 'jureckova@pp.cz'
}];

var CompanyCoursesSupportTemplate = function CompanyCoursesSupportTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H3 */.Z.H3,
      isBlack: true,
      children: t('companyCourses.support.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      children: t('companyCourses.support.description')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Persons, {
      children: TEAMS.map(function (person, personKey) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TeamPerson/* default */.Z, {
          personKey: personKey,
          image: person.image,
          name: person.name,
          position: person.position,
          phones: person.phones,
          mail: person.mail,
          withoutMargin: true
        }, personKey);
      })
    })]
  });
};

/* harmony default export */ var CompanyCoursesSupport = (CompanyCoursesSupportTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(57130);
// EXTERNAL MODULE: ./src/components/Gallery/Gallery.tsx + 1 modules
var Gallery = __webpack_require__(1061);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
;// CONCATENATED MODULE: ./src/components/LecturerCarousel/LecturerCarousel.elements.tsx



var LecturersCarousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LecturerCarouselelements__LecturersCarousel",
  componentId: "sc-104lp40-0"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(20));
var Exhibitor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LecturerCarouselelements__Exhibitor",
  componentId: "sc-104lp40-1"
})(["display:flex;flex-direction:column;width:100%;padding:0;margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20));
var ExhibitorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LecturerCarouselelements__ExhibitorTitle",
  componentId: "sc-104lp40-2"
})(["padding:", " 0 ", " 0;font-weight:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
});
var ExhibitorAnnotation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LecturerCarouselelements__ExhibitorAnnotation",
  componentId: "sc-104lp40-3"
})(["color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
});
var ExhibitorImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LecturerCarouselelements__ExhibitorImage",
  componentId: "sc-104lp40-4"
})(["width:", ";height:", ";border-radius:", ";background-position-x:center;background-position-y:center;background-repeat:no-repeat;background-size:cover;@media (min-width:", "px){width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(155), (0,polished_esm/* rem */.hO)(180), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(190), (0,polished_esm/* rem */.hO)(220));
;// CONCATENATED MODULE: ./src/components/LecturerCarousel/LecturerCarousel.tsx


function LecturerCarousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LecturerCarousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LecturerCarousel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LecturerCarousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var LecturerCarouselTemplate = function LecturerCarouselTemplate() {
  var _lecturers$sort;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      lecturers = _useState[0],
      setLecturers = _useState[1];

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    responsive: [{
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false
      }
    }]
  };
  (0,react.useEffect)(function () {
    lecturer_service/* lecturerApi.listCustomCourses */.r.listCustomCourses().then(function (_ref) {
      var data = _ref.data;
      setLecturers(data.results);
    });
  }, []);
  return (lecturers === null || lecturers === void 0 ? void 0 : lecturers.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      isBlack: true,
      children: t('homepage.lecturer.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LecturersCarousel, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, LecturerCarousel_objectSpread(LecturerCarousel_objectSpread({}, settings), {}, {
        children: lecturers === null || lecturers === void 0 ? void 0 : (_lecturers$sort = lecturers.sort(function (a, b) {
          return a.in_carousel - b.in_carousel;
        })) === null || _lecturers$sort === void 0 ? void 0 : _lecturers$sort.map(function (lecturer, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Exhibitor, {
            onClick: function onClick() {
              return router.push("".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(lecturer.slug));
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorImage, {
              style: {
                backgroundImage: "url(".concat(lecturer.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key) : (0,url_utils/* publicAssets */.VK)('/avatar_height.jpg'), ")")
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorTitle, {
              children: (0,person_utils/* formatLecturerName */.v)(lecturer)
            }), (lecturer === null || lecturer === void 0 ? void 0 : lecturer.position) && /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorAnnotation, {
              children: lecturer === null || lecturer === void 0 ? void 0 : lecturer.position
            })]
          }, key);
        })
      }))
    })]
  });
};

/* harmony default export */ var LecturerCarousel = (LecturerCarouselTemplate);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
;// CONCATENATED MODULE: ./src/pages/firemni-kurzy.tsx

















var CompanyCourses = function CompanyCourses() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.companyCourses.title'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "companyCourses.hero.title",
      imageKey: "company_courses_hero.png",
      descriptionKey: "companyCourses.hero.paragraph"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyCoursesProcess, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LecturerCarousel, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyCoursesAreas, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Gallery/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyCoursesSupport, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var firemni_kurzy = (CompanyCourses);

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ contactApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var CONTACT = 'pv/contact';
var LEASE = 'pv/contact/lease-form';
var COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';
var WITHDRAWAL = 'pv/contact/withdrawal';
var contactApi = {
  contact: function contact(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(CONTACT, data);
  },
  contactLease: function contactLease(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(LEASE, data);
  },
  withdrawal: function withdrawal(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(WITHDRAWAL, data);
  },
  companyCoursesOrder: function companyCoursesOrder(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(COMPANY_COURSES_ORDER, data);
  }
};

/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ lecturerApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'person/list/carousel';
var LIST_CUSTOM_COURSES = 'person/list/carousel/custom-courses';
var DETAIL = 'pv/person/slug';
var lecturerApi = {
  list: function list() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST);
  },
  listCustomCourses: function listCustomCourses() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST_CUSTOM_COURSES);
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  },
  upcomingTrainings: function upcomingTrainings(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  },
  upcomingConferences: function upcomingConferences(slug, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/conferences"), {
      limit: limit,
      offset: offset
    });
  },
  records: function records(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/archived/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  }
};

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-1"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-2"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-3"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-4"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(30), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx









var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      descriptionKey = _ref.descriptionKey,
      listKeys = _ref.listKeys;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        dangerouslySetInnerHTML: {
          __html: t(titleKey)
        }
      }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        dangerouslySetInnerHTML: {
          __html: t(descriptionKey)
        }
      }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: t(listKey)
            }
          })]
        }, key);
      }))]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 30213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TeamPerson; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/TeamPerson/TeamPerson.elements.tsx


var Person = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__Person",
  componentId: "sc-mlss32-0"
})(["display:flex;flex-direction:column;width:", ";margin:0 ", " ", " ", ";"], (0,polished_esm/* rem */.hO)(250), function (prop) {
  return prop.withoutMargin ? 0 : 'auto';
}, (0,polished_esm/* rem */.hO)(20), function (prop) {
  return prop.withoutMargin ? 0 : 'auto';
});
var PersonDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__PersonDetail",
  componentId: "sc-mlss32-1"
})(["background:", ";font-size:", ";padding:", " 0;height:", ";display:flex;flex-direction:column;width:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.textMedium;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(140), function (prop) {
  return prop.width ? (0,polished_esm/* rem */.hO)(prop.width) : '100%';
});
var PersonName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__PersonName",
  componentId: "sc-mlss32-2"
})(["font-weight:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
});
var PersonPosition = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__PersonPosition",
  componentId: "sc-mlss32-3"
})(["padding:", " 0 ", " 0;height:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(90));
var PersonPhone = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TeamPersonelements__PersonPhone",
  componentId: "sc-mlss32-4"
})(["padding-bottom:", ";color:", ";cursor:pointer;text-decoration:none;"], (0,polished_esm/* rem */.hO)(5), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
});
var PersonMail = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TeamPersonelements__PersonMail",
  componentId: "sc-mlss32-5"
})(["color:", ";cursor:pointer;text-decoration:none;margin-top:auto;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
var PersonImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TeamPersonelements__PersonImage",
  componentId: "sc-mlss32-6"
})(["width:", ";height:auto;border-radius:", ";"], function (prop) {
  return prop.width ? (0,polished_esm/* rem */.hO)(prop.width) : '100%';
}, (0,polished_esm/* rem */.hO)(16));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/TeamPerson/TeamPerson.tsx






var TeamPersonTemplate = function TeamPersonTemplate(_ref) {
  var personKey = _ref.personKey,
      image = _ref.image,
      name = _ref.name,
      position = _ref.position,
      _ref$phones = _ref.phones,
      phones = _ref$phones === void 0 ? [] : _ref$phones,
      mail = _ref.mail,
      width = _ref.width,
      withoutMargin = _ref.withoutMargin;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Person, {
    withoutMargin: withoutMargin,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonImage, {
      width: width,
      src: (0,url_utils/* publicAssets */.VK)(image)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PersonDetail, {
      width: width,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonPosition, {
        children: position
      }), phones.map(function (phone, phoneKey) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PersonPhone, {
          href: "href:".concat(phone),
          children: phone
        }, phoneKey);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonMail, {
        href: "mailto:".concat(mail),
        children: mail
      })]
    })]
  });
};

/* harmony default export */ var TeamPerson = (TeamPersonTemplate);

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatLecturerName; }
/* harmony export */ });
var formatLecturerName = function formatLecturerName(person) {
  if (!person) return;
  return "".concat(person.titles.before_name ? "".concat(person.titles.before_name, " ") : '').concat(person.name, " ").concat(person.surname).concat(person.titles.after_name ? " ".concat(person.titles.after_name) : '');
};

/***/ }),

/***/ 33536:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/firemni-kurzy",
      function () {
        return __webpack_require__(74066);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,6066,9392,6506,9774,2888,179], function() { return __webpack_exec__(33536); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);